export default __webpack_public_path__ + "static/Cover-a53a00d346a7e07f305a359a5307bc4e.png";